import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { authenticationService } from '../../services';

export default function AuthorizeRoute({ component: Component, ...rest }) {
  const [isReady, setIsReady] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    getAuthenticationState();
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isReady) {
          return <div/>;
        };

        if (!isAuthenticated) {
          return <Redirect to="/login" />;
        } else {
          return <Component {...props} />;
        };
      }}
    />
  );

  async function getAuthenticationState() {
    const isAuthenticated = await authenticationService.isAuthenticated();

    setIsAuthenticated(isAuthenticated);
    setIsReady(true);
  };
};